// The client list and the client card.
//
// Pure data — no imports, ever. errors.js reads he.leads.needContact at module scope,
// so a part reaching back for it would hand that read a half-built object. See he.js.
const clients = {
  clients: {
    title: 'לקוחות',
    newClient: 'לקוח חדש',
    name: 'שם',
    contact: 'איש קשר',
    phone: 'טלפון',
    email: 'דוא"ל',
    method: 'אמצעי תשלום',
    terms: 'תנאי תשלום',
    color: 'צבע בלוח',
    stage: 'סטטוס',
    owner: 'בעלים',
    // The list's view toggle: לקוחות פעילים / לקוחות לא פעילים. השבתה מסתירה לקוח
    // מהרשימה הפעילה בלבד — היא אינה מוחקת דבר, וכל הנתונים הכספיים נשארים כפי שהם.
    showActive: 'פעילים',
    showInactive: 'לא פעילים',
    // תיבת החיפוש שבכותרת המסך. מסננת את הרשימה שכבר על המסך ואינה פונה
    // לשרת, ובודקת כל עמודה שמוצגת בטבלה — וגם את כתובת הדוא"ל.
    search: 'חיפוש לפי שם, איש קשר או טלפון...',
    // אנשי הקשר של לקוח (מיגרציה 071): כמה, אחד מהם ראשי — הוא שמוצג ברשימות ובפעמון.
    contacts: 'אנשי קשר',
    contactName: 'שם',
    contactRole: 'תפקיד / הערה',
    mainContact: 'איש קשר ראשי',
    addContact: 'הוספת איש קשר',
    removeContact: 'הסרה',
    editContacts: 'עריכת אנשי קשר',
    noContacts: 'אין אנשי קשר',
    contactNeedsDetail: 'צריך שם, טלפון או דוא"ל',
    deleteContacts: 'אנשי קשר',
  },
  // The client drill-down at /clients/:id. Tabs, not a modal: a client has more
  // to say than a form's worth.
  clientCard: {
    back: 'חזרה לרשימת הלקוחות',
    // "עבודות" stays the tab's name even though it now leads with ריטיינרים: it is the
    // answer to "what work do we do for this client", and the restructure happens
    // INSIDE it rather than by renaming what a partner already knows where to find.
    // הפרסומים וההסכמים אינם לשוניות עוד — הם נמצאים בתוך העבודה והריטיינר שלהם.
    tabs: {
      details: 'פרטים',
      work: 'עבודות',
      meetings: 'פגישות',
      costs: 'כמה הלקוח עולה לנו',
    },
    // מי הלקוח — הפרופיל הקבוע. זו אותה עמודה (clients.notes) שמופיעה בטופס הליד
    // כ"מידע כללי על הליד", ולכן הרקע שנכתב על מתעניין נשאר על הלקוח ביום שסוגרים
    // איתו. ההבחנה מול שני השכנים שלה היא כל העניין (מיגרציה 057): מתי לחזור אליהם
    // הוא תאריך (follow_up_on), מה נאמר בשיחה הוא רשומה שנצברת (client_notes), ומי
    // הלקוח הוא טקסט אחד שמתעדכן — תמונה שמשתנה לאט, ולא אירוע שצריך לשמור בנפרד.
    profile: {
      heading: 'מי הלקוח',
      empty: 'עדיין לא נכתב רקע על הלקוח הזה.',
      placeholder: 'למשל: עמותה בבני ברק, שני סניפים. המנכ"לית מאשרת כל פרסום אישית. מעדיפים עיתונות כתובה, לא רדיו.',
      // תווית שדה העריכה. הטקסט אטום לחלוטין — שום חישוב אינו קורא אותו.
      label: 'רקע על הלקוח',
    },
    // THE COST TAB. Three kinds of money that must never be added together: what we
    // absorbed, what we laid out and charged on, and what was recorded before anyone was
    // asked (migration 054). Every label below says WHICH of the three it is, because a
    // bare "עלויות" on this screen would be read as the first one.
    costs: {
      absorbed: 'עלויות שנפלו עלינו',
      chargedCost: 'עלויות שחויבו ללקוח',
      // Names the cost the invoiced figure answers to, so the margin beside it can be
      // checked by eye instead of taken on trust.
      invoicedFor: 'מתוכן חויבו בפועל',
      margin: 'מרווח',
      awaiting: 'עלויות שממתינות לחיוב',
      awaitingPlanned: 'מתוכנן לחיוב',
      plannedMissing: (n) => (n === 1 ? 'אחת ללא סכום שנקבע' : `${n} ללא סכום שנקבע`),
      // Never folded into the absorbed total. We do not know which it was.
      unstated: 'עלויות ללא ציון',
      cancelledCharges: (n) => (n === 1
        ? 'עלות אחת חויבה בחשבונית שבוטלה:'
        : `${n} עלויות חויבו בחשבוניות שבוטלו:`),
      byUnitTitle: 'לפי עבודה',
      job: 'עבודה',
      topic: 'נושא בריטיינר',
      colAbsorbed: 'נפל עלינו',
      colCharged: 'חויב ללקוח',
      colInvoiced: 'סכום החיוב',
      colUnstated: 'ללא ציון',
      // A charge that has not been raised yet — shown in the charge column so a cost
      // marked for the client is never a blank cell.
      planned: 'מתוכנן',
      // A row holding expenses that all cost 0. States the fact rather than calling it a
      // mistake: goods received free genuinely cost nothing, and the stored 0 looks the
      // same either way. Seeing it on the cost screen is what makes a mistyped one
      // findable — it used to render as a line of dashes and say nothing at all.
      zeroCost: (n) => (n === 1
        ? 'עלה לנו 0'
        : `${n} הוצאות, עלו לנו 0`),
      standaloneHeading: 'עבודות חד־פעמיות',
      unnamedRetainer: 'ריטיינר ללא שם',
      empty: 'עדיין לא נרשמו עלויות על העבודות של הלקוח.',
    },
    // The work tab's two sections. The split is on whether a job has a ריטיינר, not on
    // income_source — a brokerage job that bills its own margin can still sit under a
    // retainer, and it belongs with its retainer, not with the one-offs.
    retainersHeading: 'ריטיינרים',
    standaloneHeading: 'פרויקטים חד־פעמיים',
    // Rendered as "{n} עבודות" on a retainer's own collapsed header, so it can only be
    // read as that retainer's.
    topicsInRetainer: 'עבודות',
    openRetainer: 'פתיחת הריטיינר',
    openJob: 'פתיחת העבודה',
    // On a collapsed retainer this is the fact worth surfacing: an engagement running
    // with no signed contract on file is exactly what a scan should catch.
    hasAgreement: 'הסכם חתום',
    noAgreement: 'אין הסכם',
    // One toggle for the whole card — the archive is a view of this client's contracts,
    // not of one retainer.
    showAgreementsArchive: 'ארכיון ההסכמים',
    showAgreementsLive: 'חזרה להסכמים הפעילים',
    publicationsCount: 'פרסומים',
    noOwner: 'ללא בעלים',
    notFound: 'הלקוח לא נמצא.',
    deactivate: 'סימון כלא פעיל',
    activate: 'החזרה ללקוחות פעילים',
    inactiveBadge: 'לא פעיל',
    // Deleting a client is the widest destructive action in the system: it takes every
    // retainer, every עבודה and every קובץ of that client. It lives at the bottom of the
    // details tab — not in the header beside "back to list", where a mis-click lands.
    deleteClient: 'מחיקת לקוח',
    deleteScope: 'יימחקו הלקוח וכל מה ששייך לו: הריטיינרים, העבודות, החשבוניות, התשלומים, ההוצאות, המשימות, הפרסומים והקבצים.',
    deleteRetainersHeading: 'ריטיינרים שיימחקו:',
    deleteJobsHeading: 'עבודות עצמאיות שיימחקו:',
    deleteRetainers: 'ריטיינרים',
    deleteJobs: 'עבודות',
    // Rendered on a named retainer's own line ("ריטיינר עירייה · 3 עבודות"), one level
    // in from the flat count above it and from the "עבודות עצמאיות שיימחקו" list below.
    deleteTopicsInside: 'עבודות',
    // A lead is the same row as a client, and usually has nothing beneath it.
    deleteLeadNote: 'זהו ליד — מחיקתו מוחקת גם את המשימות שנפתחו עליו.',
    deleteBalanceNote: 'המאזן בין השותפים יתעדכן מיד — כל ההכנסות והעלויות של הלקוח יורדות ממנו.',
  },
};

export default clients;
